import { BsSearch } from "react-icons/bs";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import BlogsCard from "./BlogsCard";
import { getBlogs } from "../../redux/Action";
import { months } from "../../Public/constants";
import usePagination from "../../Hooks/usePagination";

const Blogs = () => {
  const { isLoading, isError, blogs, blogCount } = useSelector(
    (state) => state
  );
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();

  let [page, setPage] = useState(1);
  const PER_PAGE = 6;

  const count = Math.ceil(blogs.length / PER_PAGE);
  const { jump, currentData } = usePagination(blogs, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    jump(p);
  };

  useEffect(() => {
    document.title = "Blogshog | Blogs";
    getBlogs(dispatch, search);
  }, [search]);

  if (blogCount === 0 && !isLoading && !search) {
    return (
      <section className="h-screen lg:h-[auto]">
        <p className="text-xl text-center mt-10 dark:text-white">
          No blogs to show!
        </p>
      </section>
    );
  }
  return (
    <section className="w-[80%] m-auto py-14">
      <div className="flex justify-center dark:text-white">
        <div className="bg-[#F1F1F1] dark:bg-[#1d1e2b] w-[30rem] px-6 py-2 rounded-md flex items-center gap-4">
          <BsSearch className="text-xl" />
          <input
            type="text"
            placeholder="search for blogs by topic or keywords"
            className="bg-transparent outline-none border-none w-full"
            onInput={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div>
        <>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          ) : isError ? (
            <Stack
              sx={{ width: "60%", margin: "2rem auto", height: "100vh" }}
              spacing={2}
            >
              <Alert severity="error">
                Something went wrong while fetching data.
              </Alert>
            </Stack>
          ) : (
            <>
              <section className="text-gray-600 dark:text-white">
                <div className="container px-5 py-14 mx-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {currentData().map((el, i) => {
                      const date = el.createdAt.substring(8, 10);
                      const month_in_num =
                        (el.createdAt.substring(5, 7) * 10) / 10;
                      const month = months[month_in_num - 1];
                      const year = el.createdAt.substring(0, 4);
                      return (
                        <BlogsCard
                          date={date}
                          key={i}
                          month={month}
                          year={year}
                          el={el}
                        />
                      );
                    })}
                  </div>
                </div>
                {blogCount > 6 && (
                  <div className="flex justify-center pb-16">
                    <Stack spacing={2}>
                      <Pagination
                        count={count}
                        variant="outlined"
                        shape="rounded"
                        page={page}
                        onChange={handleChange}
                      />
                    </Stack>
                  </div>
                )}
              </section>
            </>
          )}
        </>
      </div>
    </section>
  );
};

export default Blogs;
